import React from 'react'
import { AiOutlineLogin, AiOutlineLogout } from 'react-icons/ai'
import { BiSolidCartAlt } from 'react-icons/bi'
import { HiOutlineReceiptTax, HiOutlineServer, HiOutlineSparkles, HiOutlineTicket, HiOutlineUsers } from 'react-icons/hi'
import { IoIosSettings, IoMdCart, IoMdHome } from 'react-icons/io'
import { MdCategory, MdOutlineInventory, MdProductionQuantityLimits } from 'react-icons/md'
import { RiAdminFill } from 'react-icons/ri'
import { RxDashboard } from 'react-icons/rx'
import { TbTruckDelivery } from 'react-icons/tb'
import { TiUser } from 'react-icons/ti'

export const SidebarData = [
    {
        title: 'Home',
        path: '/',
        icon: <IoMdHome />,
        cName: 'nav-text',
        // shoppers only: admins and managers start at the Dashboard
        user: true,
        default: false
    },
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: <RxDashboard/>,
        cName: 'nav-text',
        user: false,
        default: false
    },
    {
        title: 'Inventory',
        path: '/shop/inventory',
        icon: <MdOutlineInventory />,
        cName: 'nav-text',
        user: false,
        default: false
    },
    {
        title: 'Delivery',
        path: '/admin/orders',
        icon: <TbTruckDelivery />,
        cName: 'nav-text',
        user: false,
        default: false
    },
    {
        title: 'Expenses',
        path: '/admin/expenses',
        icon: <HiOutlineReceiptTax />,
        cName: 'nav-text',
        user: false,
        default: false
    },
    {
        title: 'My Orders',
        path: '/orders',
        icon: <BiSolidCartAlt />,
        cName: 'nav-text',
        user: true,
        default: false
    },
    {
        title: 'Coupons',
        path: '/admin/coupons',
        icon: <HiOutlineTicket />,
        cName: 'nav-text',
        user: false,
        default: false,
        // admins only: discounts change what the shop earns
        adminOnly: true
    },
    {
        title: 'Users',
        path: '/admin/users',
        icon: <HiOutlineUsers />,
        cName: 'nav-text',
        user: false,
        default: false,
        // admins only: change who is a Manager or Admin
        adminOnly: true
    },
    {
        title: 'Services',
        path: '/admin/services',
        icon: <HiOutlineServer />,
        cName: 'nav-text',
        user: false,
        default: false,
        // admins only: hosting, keys and costs; shows how many services need attention
        adminOnly: true,
        serviceWarnings: true
    },
    {
        title: 'Settings',
        path: '/settings',
        icon: <IoIosSettings />,
        cName: 'nav-text',
        user: false,
        default: false,
        // admins only; managers see every other admin menu
        adminOnly: true
    },
    {
        title: 'AI Help',
        path: '/help',
        icon: <HiOutlineSparkles />,
        cName: 'nav-text',
        user: true,
        default: false,
        // shoppers only, while an admin has AI Help switched on (Settings)
        aiHelp: true,
        badge: 'New'
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: <TiUser />,
        cName: 'nav-text',
        user: true,
        default: true
    }
]
export const logoutData =
{
    title: 'Logout',
    path: '/logout',
    icon: <AiOutlineLogout />,
    cName: 'nav-text',
    index: 10
}

export const SidebarDataNewUser = [
    {
        title: 'Home',
        path: '/',
        icon: <IoMdHome />,
        cName: 'nav-text'
    },
    {
        title: 'Login',
        path: '/login',
        icon: <AiOutlineLogin />,
        cName: 'nav-text'
    },
    {
        title: 'Register',
        path: '/register',
        icon: <TiUser />,
        cName: 'nav-text'
    }

]

export const SidebarDataUser = [
    {
        title: 'Home',
        path: '/',
        icon: <IoMdHome />,
        cName: 'nav-text'
    },
    {
        title: 'My Orders',
        path: '/orders',
        icon: <BiSolidCartAlt />,
        cName: 'nav-text'
    },
    {
        title: 'Cart',
        path: '/cart',
        icon: <IoMdCart />,
        cName: 'nav-text'
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: <TiUser />,
        cName: 'nav-text'
    }
]